export const defaultChartData = {
  // x-axis labels
  labels: [],
  datasets: [
    {
      data: [],
    },
  ],
};
